"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.type.target': 'Target',
    'slotData.type.goal': 'Goal',
};
